module.exports = __webpack_public_path__ + "img/card_bologna_adaptivelight_background.cbe69fc3.png";